export default [
  '$window',
  '$uibModalInstance',
  'activeDraftService',
  function ($window, $uibModalInstance, activeDraftService) {
    // TODO удалить модалку когда будет сделана нотификация в правом углу

    const deleteDraft = () => {
      const guid = activeDraftService.getDraftGuid();
      if (guid) {
        return activeDraftService.deleteDraft(guid).catch(() => {
          // Ошибка может быть если API метод удаления драфта не сработал корректно, но нам все равно надо перезагрузить страницу
          // Не обработанное исключение, дальше выполнится следующий then
          // Если нужно спустить ошибку ниже по цепочке, нужно делать Promise.reject();
          // Нам это не нужно, поэтому возвращается undefined и ниже по цепочке будет выполнен then
        });
      }

      return Promise.resolve();
    };

    this.createNew = () => {
      deleteDraft().then(() => {
        angular.element($window).on('beforeunload', () => {
          $window.scrollTo(0, 0);
        });
        $uibModalInstance.dismiss('sent');
        $window.location.reload();
      });
    };

    this.close = () => {
      $uibModalInstance.dismiss('sent');
    };
  },
];
